module.exports = __webpack_public_path__ + "photo-6.b0dcd4b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/images/apartments/full/photo-6.jpg
// module id = 617
// module chunks = 0